/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.ts to modify the generation of this file.


import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-nextjs';


import * as Breadcrumb from 'src/jss/components/Breadcrumb';
import * as CalamitiesBanner from 'src/jss/components/CalamitiesBanner';
import * as CardsSection from 'src/jss/components/CardsSection';
import * as CongestionChecker from 'src/jss/components/CongestionChecker';
import * as CongestionCheckerParticulier from 'src/jss/components/CongestionCheckerParticulier';
import * as CongestionReportsDetailContainer from 'src/jss/components/CongestionReportsDetailContainer';
import * as CongestionReportsHero from 'src/jss/components/CongestionReportsHero';
import * as CongestionReportsOverview from 'src/jss/components/CongestionReportsOverview';
import * as CongestionReportsParagraph from 'src/jss/components/CongestionReportsParagraph';
import * as ContentBlock from 'src/jss/components/ContentBlock';
import * as CookieDeclaration from 'src/jss/components/CookieDeclaration';
import * as DialogueText from 'src/jss/components/DialogueText';
import * as EditPageCTA from 'src/jss/components/EditPageCTA';
import * as Faq from 'src/jss/components/Faq';
import * as FollowUpStepsSection from 'src/jss/components/FollowUpStepsSection';
import * as Footer from 'src/jss/components/Footer';
import * as Header from 'src/jss/components/Header';
import * as Highlight from 'src/jss/components/Highlight';
import * as HomepageHero from 'src/jss/components/HomepageHero';
import * as Iframe from 'src/jss/components/Iframe';
import * as ImageGallery from 'src/jss/components/ImageGallery';
import * as ImageWithText from 'src/jss/components/ImageWithText';
import * as InfoSection from 'src/jss/components/InfoSection';
import * as InspirationalCards from 'src/jss/components/InspirationalCards';
import * as LinkBlock from 'src/jss/components/LinkBlock';
import * as MeterManuals from 'src/jss/components/MeterManuals';
import * as NewsArticleDetail from 'src/jss/components/NewsArticleDetail';
import * as NewsOverview from 'src/jss/components/NewsOverview';
import * as OutageHero from 'src/jss/components/OutageHero';
import * as OutageLocationContainer from 'src/jss/components/OutageLocationContainer';
import * as OutagesOnLocation from 'src/jss/components/OutagesOnLocation';
import * as OutagesOverview from 'src/jss/components/OutagesOverview';
import * as OutagesSMSService from 'src/jss/components/OutagesSMSService';
import * as Paragraph from 'src/jss/components/Paragraph';
import * as PreviewSearch from 'src/jss/components/PreviewSearch';
import * as ProjectOverview from 'src/jss/components/ProjectOverview';
import * as SearchResults from 'src/jss/components/SearchResults';
import * as SideImageHero from 'src/jss/components/SideImageHero';
import * as SimpleHero from 'src/jss/components/SimpleHero';
import * as SubpageHero from 'src/jss/components/SubpageHero';
import * as TableOfContentsContainer from 'src/jss/components/TableOfContentsContainer';
import * as TextWithSideImage from 'src/jss/components/TextWithSideImage';
import * as Video from 'src/jss/components/Video';
import * as Wizard from 'src/jss/components/Wizard';
import * as form from 'src/jss/components/form';

export const components = new Map();

components.set('Breadcrumb', Breadcrumb);
components.set('CalamitiesBanner', CalamitiesBanner);
components.set('CardsSection', CardsSection);
components.set('CongestionChecker', CongestionChecker);
components.set('CongestionCheckerParticulier', CongestionCheckerParticulier);
components.set('CongestionReportsDetailContainer', CongestionReportsDetailContainer);
components.set('CongestionReportsHero', CongestionReportsHero);
components.set('CongestionReportsOverview', CongestionReportsOverview);
components.set('CongestionReportsParagraph', CongestionReportsParagraph);
components.set('ContentBlock', ContentBlock);
components.set('CookieDeclaration', CookieDeclaration);
components.set('DialogueText', DialogueText);
components.set('EditPageCTA', EditPageCTA);
components.set('Faq', Faq);
components.set('FollowUpStepsSection', FollowUpStepsSection);
components.set('Footer', Footer);
components.set('Header', Header);
components.set('Highlight', Highlight);
components.set('HomepageHero', HomepageHero);
components.set('Iframe', Iframe);
components.set('ImageGallery', ImageGallery);
components.set('ImageWithText', ImageWithText);
components.set('InfoSection', InfoSection);
components.set('InspirationalCards', InspirationalCards);
components.set('LinkBlock', LinkBlock);
components.set('MeterManuals', MeterManuals);
components.set('NewsArticleDetail', NewsArticleDetail);
components.set('NewsOverview', NewsOverview);
components.set('OutageHero', OutageHero);
components.set('OutageLocationContainer', OutageLocationContainer);
components.set('OutagesOnLocation', OutagesOnLocation);
components.set('OutagesOverview', OutagesOverview);
components.set('OutagesSMSService', OutagesSMSService);
components.set('Paragraph', Paragraph);
components.set('PreviewSearch', PreviewSearch);
components.set('ProjectOverview', ProjectOverview);
components.set('SearchResults', SearchResults);
components.set('SideImageHero', SideImageHero);
components.set('SimpleHero', SimpleHero);
components.set('SubpageHero', SubpageHero);
components.set('TableOfContentsContainer', TableOfContentsContainer);
components.set('TextWithSideImage', TextWithSideImage);
components.set('Video', Video);
components.set('Wizard', Wizard);
components.set('form', form);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
